import profile from './profile.png'
import questsCompleted from './quests-completed.png'
import itemsFound from './items-found.png'

export default [profile, questsCompleted, itemsFound]
